export default {
  view_only: 'View Only',
  editable: 'Editable',
  partly_editable: 'Partly Editable',
};
